
export function ehTurmaAEEouACP (cdtpatend, cdinstruc, cdserie) {
    return (cdtpatend == 5) ||
          (cdinstruc == 48 && cdserie == 1 && cdtpatend === 4) ||
          (cdinstruc == 94 && cdserie == 1 && cdtpatend === 4)
}


